module.exports = __webpack_public_path__ + "img/empreendimento-logo-37.48cc126b.png";